export function printSizes(...sizes: (number | null | undefined)[]): string {
  return sizes.map((size) => `${size ?? "-"}″`).join(" x ");
}
